<script lang="ts">
  import { onMount } from "svelte";
  import { errorTracker, translate } from "lib";
  import { dialogData, showAlert } from "stores";
  import { ButtonComponent, InputField } from "ui";

  let data: any;

  let form = {
    name: {
      value: "",
      error: "",
    },
    pdf: {
      value: "",
      error: "",
    },
  };

  let disabled = true;
  let isLoading = false;
  let files: FileList;
  const dialogType = data.meal ? translate("EDIT") : translate("CREATE");

  const onInput = (field: string): void => {
    // nzm sto svelte jebe, loguje predhodni value, moguce da je flowbite file input
    // component bug, ovo je kao "fix"
    setTimeout(() => {
      const { value } = form[field];

      if (field === "name") {
        if (value.length === 0) {
          form[field].error = translate("FIELD_REQUIRED");
        } else if (value.length < 2) {
          form[field].error = translate("FIELD_MINIMUM_2");
        } else if (value.length > 320) {
          form[field].error = translate("FIELD_MAXIMUM_320");
        } else {
          form[field].error = "";
        }
      }

      if (field === "pdf") {
        if (files.length === 0) {
          form[field].error = translate("FIELD_REQUIRED");
        } else {
          form[field].error = "";
        }
      }

      disabled = Object.values(form).some((field) => field.error !== "");
    }, 100);
  };

  const onSubmit = async (): Promise<void> => {
    isLoading = true;

    const formData = new FormData();
    let response: any;

    try {
      return;
      if (data.meal) {
        const url = ``;

        if (files) {
          formData.append("pdf", files[0]);
        }

        formData.append(
          "meal",
          JSON.stringify({
            name: form.name.value,
            entityType: 3,
          })
        );

        response = {};

        data.executeFunction(response);
      } else {
        const url = ``;

        formData.append("pdf", files[0]);
        formData.append(
          "meal",
          JSON.stringify({
            name: form.name.value,
            entityType: 3,
          })
        );

        response = {};

        data.executeFunction(response);
      }

      $dialogData.data = {};
      $dialogData.type = "";
      $showAlert.color = "black";
      $showAlert.message = `Created a new PDF meal.`;
    } catch (error) {
      errorTracker.captureError(error as Error, 'error', {
        component: 'CreateEditPDFMeal',
        action: 'onSubmit',
        context: data.meal ? 'Failed to edit PDF meal' : 'Failed to create PDF meal',
        mealId: data.meal?.id,
        mealName: form.name.value
      });
      isLoading = false;
      $showAlert.color = "red-400";
      $showAlert.message = `There was an error creating PDF meal.`;
    }
  };

  onMount((): void => {
    if (data.meal) {
      const { name } = data.meal;

      if (name) {
        form.name.value = name;
        onInput("name");
      }
    }
  });

  export { data };
</script>

<div class="p-4 flex flex-col gap-4">
  <div class="text-center font-semibold">
    {dialogType} PDF {translate("MEAL").toLowerCase()}
  </div>

  <form class="flex flex-col gap-4" on:submit|preventDefault={onSubmit}>
    <InputField
      label={translate("NAME")}
      error={form.name.error}
      bind:value={form.name.value}
      on:input={() => onInput("name")}
    />

    <input
      type="file"
      bind:value={form.pdf.value}
      bind:files
      on:change={() => onInput("pdf")}
    />

    <div class="flex justify-center">
      <ButtonComponent type="submit" {disabled} {isLoading}>
        {dialogType}
      </ButtonComponent>
    </div>
  </form>
</div>
